import React from 'react';
import { Project } from '../types/DeveloperTypes';

interface ProjectSelectorProps {
  projects: Project[];
  selectedProjectId: number | null;
  onSelectProject: (projectId: number) => void;
}

// Project Selector Component
const ProjectSelector: React.FC<ProjectSelectorProps> = ({ 
  projects, 
  selectedProjectId, 
  onSelectProject 
}) => {
  if (!projects || projects.length === 0) {
    return (
      <div style={{ marginBottom: '1.5rem', color: '#999' }}>
        No projects available
      </div>
    );
  }

  return (
    <div style={{ 
      marginBottom: '1.5rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem'
    }}>
      <label htmlFor="project-select" style={{ fontWeight: 500 }}>Project:</label>
      <select
        id="project-select"
        value={selectedProjectId || ''}
        onChange={(e) => onSelectProject(Number(e.target.value))}
        style={{
          padding: '0.5rem',
          borderRadius: '0.25rem',
          border: '1px solid #e0e0e0',
          backgroundColor: '#fff',
          minWidth: '200px',
          fontSize: '0.9rem'
        }}
      >
        {projects.map((project) => (
          <option key={project.projectId} value={project.projectId}>
            {project.projectName}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ProjectSelector;
